import { render, staticRenderFns } from "./SemiologiaFisiatrica.vue?vue&type=template&id=276dde17"
import script from "./SemiologiaFisiatrica.vue?vue&type=script&lang=js"
export * from "./SemiologiaFisiatrica.vue?vue&type=script&lang=js"
import style0 from "./SemiologiaFisiatrica.vue?vue&type=style&index=0&id=276dde17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports